import React, { Fragment } from 'react';
import {
  Accordion,
  Button,
  Checkbox,
  Divider,
  Form,
  Grid,
  Icon,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { TitledCard } from 'Components';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { PHYSICAL_INVENTORY_FORM_NAME } from 'Common/FormEnum';
import { PhysicalInventoryReportEnum } from 'Common/FieldEnum';
import SelectSitesTable from 'Common/SelectSitesTable';
import { PrintSortTypeEnum } from 'Common/Constants/Enumeration/CommonEnum';
import {
  FilterOptionsEnum,
  GroupOptionsEnum,
} from 'Common/Constants/Enumeration/PhysicalInventoryReportEnum';
import { SecurityPreferences } from 'Common/Security/SecurityPreferences';
import { PreferencesEnum } from 'Common/Security/PreferencesEnum';

import { filterOptions, sortOptions, groupOptions } from './../helper';

const PhysicalInventoryReportComponent = props => {
  const {
    setSortByOption,
    sortOptionsValue,
    setFilterByOption,
    filterOptionsValue,
    setGroupByOption,
    groupOptionsValue,
    setCurrentOnHand,
    clearFilters,
    currentOnHand,
    setSelectedSites,
    activeIndexForFilter,
    handleClick,
    reactTableRef,
    getSitesCallback,
  } = props;

  return (
    <Fragment>
      <Form>
        <Accordion fluid styled>
          <Accordion.Title
            active={!activeIndexForFilter}
            index={0}
            onClick={handleClick}
          >
            <Icon name="dropdown" />
          </Accordion.Title>
          <Accordion.Content active={!activeIndexForFilter}>
            <Grid className="grid-spacing">
              <Grid.Row columns={2}>
                <Grid.Column width={11} verticalAlign={'bottom'}>
                  <TitledCard title={'Filter By'}>
                    <ReduxFormButtonGroup
                      options={filterOptions}
                      value={filterOptionsValue}
                      formName={PHYSICAL_INVENTORY_FORM_NAME}
                      fieldName={PhysicalInventoryReportEnum.FilterOptions}
                      type={'button'}
                      onChange={setFilterByOption}
                    />
                  </TitledCard>
                </Grid.Column>
                <Grid.Column width={5} style={{ marginTop: '45px' }}>
                  <SecurityPreferences
                    scope={PreferencesEnum.PhysicalReportIncludeCurrentOnHand}
                  >
                    {disabled => {
                      return (
                        <Checkbox
                          label="Include Current On Hand"
                          toggle
                          checked={disabled ? false : currentOnHand}
                          onChange={setCurrentOnHand}
                          name={PhysicalInventoryReportEnum.CurrentOnHand}
                          disabled={disabled}
                        />
                      );
                    }}
                  </SecurityPreferences>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={2}>
                <Grid.Column width={11} verticalAlign={'bottom'}>
                  <TitledCard title={'Sort By'}>
                    <ReduxFormButtonGroup
                      options={sortOptions}
                      value={sortOptionsValue}
                      formName={PHYSICAL_INVENTORY_FORM_NAME}
                      fieldName={PhysicalInventoryReportEnum.SortOptions}
                      type={'button'}
                      onChange={setSortByOption}
                    />
                  </TitledCard>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={2}>
                <Grid.Column width={11} verticalAlign={'bottom'}>
                  <TitledCard title={'Group By'}>
                    <ReduxFormButtonGroup
                      options={groupOptions}
                      value={groupOptionsValue}
                      formName={PHYSICAL_INVENTORY_FORM_NAME}
                      fieldName={PhysicalInventoryReportEnum.GroupOptions}
                      type={'button'}
                      onChange={setGroupByOption}
                    />
                  </TitledCard>
                </Grid.Column>
                <Grid.Column
                  width={3}
                  textAlign={'right'}
                  style={{ marginTop: '45px' }}
                  floated={'right'}
                >
                  <Button
                    className={'clear-filters-button'}
                    content="Clear Filters"
                    onClick={clearFilters}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Content>
        </Accordion>
        <Divider horizontal />
        <TitledCard>
          <SelectSitesTable
            onChange={setSelectedSites}
            getSitesCallback={getSitesCallback}
            isActive={true}
            isLicensed={false}
            showPageSizeOptions={true}
            defaultPageSize={20}
            filterable={true}
            sortable={true}
            tableProps={{ ref: reactTableRef }}
          />
        </TitledCard>
      </Form>
    </Fragment>
  );
};

PhysicalInventoryReportComponent.propTypes = {
  setSortByOption: PropTypes.func,
  setFilterByOption: PropTypes.func,
  setGroupByOption: PropTypes.func,
  setCurrentOnHand: PropTypes.func,
  clearFilters: PropTypes.func,
  setSelectedSites: PropTypes.func,
  handleClick: PropTypes.func,
  getSitesCallback: PropTypes.func,
  sortOptionsValue: PropTypes.number,
  filterOptionsValue: PropTypes.number,
  groupOptionsValue: PropTypes.number,
  activeIndexForFilter: PropTypes.number,
  currentOnHand: PropTypes.bool,
  reactTableRef: PropTypes.object,
};

PhysicalInventoryReportComponent.defaultProps = {
  setSortByOption: () => {},
  setFilterByOption: () => {},
  setGroupByOption: () => {},
  setCurrentOnHand: () => {},
  clearFilters: () => {},
  setSelectedSites: () => {},
  handleClick: () => {},
  getSitesCallback: () => {},
  sortOptionsValue: PrintSortTypeEnum.ItemCode,
  filterOptionsValue: FilterOptionsEnum.OnHandItems,
  groupOptionsValue: GroupOptionsEnum.None,
  activeIndexForFilter: 0,
  currentOnHand: true,
  reactTableRef: null,
};

export default PhysicalInventoryReportComponent;



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/physicalinventoryreport/components/PhysicalInventoryReport.js